function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.83 8.502L10.246 2.95a.416.416 0 00-.492 0L2.17 8.502a.416.416 0 10.491.671L10 3.8l7.339 5.373a.414.414 0 00.58-.09.416.416 0 00-.09-.58z",
  fill: "#1C4F6D",
  stroke: "#1C4F6D",
  strokeWidth: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.82 9.267a.416.416 0 00-.415.416V16.3h-3.326v-3.612A2.081 2.081 0 0010 10.609a2.081 2.081 0 00-2.079 2.079V16.3H4.596V9.683a.416.416 0 00-.832 0v7.033c0 .23.186.415.416.415h4.157a.415.415 0 00.416-.415v-4.028c0-.688.56-1.248 1.247-1.248.688 0 1.247.56 1.247 1.248v4.028l.002.032a.415.415 0 00.414.383h4.157c.23 0 .416-.186.416-.415V9.683a.416.416 0 00-.416-.416z",
  fill: "#1C4F6D",
  stroke: "#1C4F6D",
  strokeWidth: 0.2
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.b889d18b.svg";
export { ForwardRef as ReactComponent };